export interface CityData {
  city: string;
  state: string;
  stateAbbr: string;
  airportName: string;
  fboName: string;
  nearbyCities: Array<{ name: string; path: string }>;
  longDistanceRoutes: Array<{ from: string; to: string }>;
}

export const cityData: Record<string, CityData> = {
  // Massachusetts
  'boston-ma': {
    city: 'Boston',
    state: 'Massachusetts',
    stateAbbr: 'MA',
    airportName: 'Logan International Airport',
    fboName: 'Signature Aviation Boston Logan',
    nearbyCities: [
      { name: 'Cambridge, MA', path: '/chauffeur-cambridge-ma' },
      { name: 'New York, NY', path: '/chauffeur-new-york-ny' },
      { name: 'Providence, RI', path: '/chauffeur-providence-ri' }
    ],
    longDistanceRoutes: [
      { from: 'Boston', to: 'New York City' },
      { from: 'Boston', to: 'Washington DC' },
      { from: 'Boston', to: 'Philadelphia' }
    ]
  },
  'cambridge-ma': {
    city: 'Cambridge',
    state: 'Massachusetts',
    stateAbbr: 'MA',
    airportName: 'Logan International Airport',
    fboName: 'Signature Aviation Boston Logan',
    nearbyCities: [
      { name: 'Boston, MA', path: '/chauffeur-boston-ma' },
      { name: 'Somerville, MA', path: '/chauffeur-somerville-ma' },
      { name: 'Medford, MA', path: '/chauffeur-medford-ma' }
    ],
    longDistanceRoutes: [
      { from: 'Cambridge', to: 'New York City' },
      { from: 'Cambridge', to: 'Boston' },
      { from: 'Cambridge', to: 'Providence' }
    ]
  },

  // New York
  'new-york-ny': {
    city: 'New York City',
    state: 'New York',
    stateAbbr: 'NY',
    airportName: 'John F. Kennedy International Airport',
    fboName: 'Signature Aviation Teterboro',
    nearbyCities: [
      { name: 'Albany, NY', path: '/chauffeur-albany-ny' },
      { name: 'Boston, MA', path: '/chauffeur-boston-ma' },
      { name: 'Newark, NJ', path: '/chauffeur-newark-nj' }
    ],
    longDistanceRoutes: [
      { from: 'New York City', to: 'Boston' },
      { from: 'New York City', to: 'Washington DC' },
      { from: 'New York City', to: 'Philadelphia' }
    ]
  },
  'albany-ny': {
    city: 'Albany',
    state: 'New York',
    stateAbbr: 'NY',
    airportName: 'Albany International Airport',
    fboName: 'Signature Aviation Albany',
    nearbyCities: [
      { name: 'New York City, NY', path: '/chauffeur-new-york-ny' },
      { name: 'Schenectady, NY', path: '/chauffeur-schenectady-ny' },
      { name: 'Troy, NY', path: '/chauffeur-troy-ny' }
    ],
    longDistanceRoutes: [
      { from: 'Albany', to: 'New York City' },
      { from: 'Albany', to: 'Boston' },
      { from: 'Albany', to: 'Montreal' }
    ]
  },

  // New Jersey
  'newark-nj': {
    city: 'Newark',
    state: 'New Jersey',
    stateAbbr: 'NJ',
    airportName: 'Newark Liberty International Airport',
    fboName: 'Signature Aviation Newark',
    nearbyCities: [
      { name: 'Princeton, NJ', path: '/chauffeur-princeton-nj' },
      { name: 'New York City, NY', path: '/chauffeur-new-york-ny' },
      { name: 'Jersey City, NJ', path: '/chauffeur-jersey-city-nj' }
    ],
    longDistanceRoutes: [
      { from: 'Newark', to: 'New York City' },
      { from: 'Newark', to: 'Philadelphia' },
      { from: 'Newark', to: 'Boston' }
    ]
  },
  'princeton-nj': {
    city: 'Princeton',
    state: 'New Jersey',
    stateAbbr: 'NJ',
    airportName: 'Princeton Airport',
    fboName: 'Signature Aviation Trenton',
    nearbyCities: [
      { name: 'Newark, NJ', path: '/chauffeur-newark-nj' },
      { name: 'Philadelphia, PA', path: '/chauffeur-philadelphia-pa' },
      { name: 'Trenton, NJ', path: '/chauffeur-trenton-nj' }
    ],
    longDistanceRoutes: [
      { from: 'Princeton', to: 'New York City' },
      { from: 'Princeton', to: 'Philadelphia' },
      { from: 'Princeton', to: 'Newark' }
    ]
  },

  // Pennsylvania
  'philadelphia-pa': {
    city: 'Philadelphia',
    state: 'Pennsylvania',
    stateAbbr: 'PA',
    airportName: 'Philadelphia International Airport',
    fboName: 'Signature Aviation Philadelphia',
    nearbyCities: [
      { name: 'Pittsburgh, PA', path: '/chauffeur-pittsburgh-pa' },
      { name: 'New York City, NY', path: '/chauffeur-new-york-ny' },
      { name: 'Washington DC', path: '/chauffeur-washington-dc' }
    ],
    longDistanceRoutes: [
      { from: 'Philadelphia', to: 'New York City' },
      { from: 'Philadelphia', to: 'Washington DC' },
      { from: 'Philadelphia', to: 'Boston' }
    ]
  },
  'pittsburgh-pa': {
    city: 'Pittsburgh',
    state: 'Pennsylvania',
    stateAbbr: 'PA',
    airportName: 'Pittsburgh International Airport',
    fboName: 'Signature Aviation Pittsburgh',
    nearbyCities: [
      { name: 'Philadelphia, PA', path: '/chauffeur-philadelphia-pa' },
      { name: 'Cleveland, OH', path: '/chauffeur-cleveland-oh' },
      { name: 'Columbus, OH', path: '/chauffeur-columbus-oh' }
    ],
    longDistanceRoutes: [
      { from: 'Pittsburgh', to: 'Philadelphia' },
      { from: 'Pittsburgh', to: 'New York City' },
      { from: 'Pittsburgh', to: 'Washington DC' }
    ]
  },

  // Maine
  'portland-me': {
    city: 'Portland',
    state: 'Maine',
    stateAbbr: 'ME',
    airportName: 'Portland International Jetport',
    fboName: 'Signature Aviation Portland',
    nearbyCities: [
      { name: 'Bangor, ME', path: '/chauffeur-bangor-me' },
      { name: 'Boston, MA', path: '/chauffeur-boston-ma' },
      { name: 'Portsmouth, NH', path: '/chauffeur-portsmouth-nh' }
    ],
    longDistanceRoutes: [
      { from: 'Portland', to: 'Boston' },
      { from: 'Portland', to: 'New York City' },
      { from: 'Portland', to: 'Bangor' }
    ]
  },
  'bangor-me': {
    city: 'Bangor',
    state: 'Maine',
    stateAbbr: 'ME',
    airportName: 'Bangor International Airport',
    fboName: 'Signature Aviation Bangor',
    nearbyCities: [
      { name: 'Portland, ME', path: '/chauffeur-portland-me' },
      { name: 'Augusta, ME', path: '/chauffeur-augusta-me' },
      { name: 'Lewiston, ME', path: '/chauffeur-lewiston-me' }
    ],
    longDistanceRoutes: [
      { from: 'Bangor', to: 'Portland' },
      { from: 'Bangor', to: 'Boston' },
      { from: 'Bangor', to: 'Montreal' }
    ]
  },

  // Washington DC
  'washington-dc': {
    city: 'Washington',
    state: 'District of Columbia',
    stateAbbr: 'DC',
    airportName: 'Ronald Reagan Washington National Airport',
    fboName: 'Signature Aviation Washington Dulles',
    nearbyCities: [
      { name: 'Arlington, VA', path: '/chauffeur-arlington-va' },
      { name: 'Bethesda, MD', path: '/chauffeur-bethesda-md' },
      { name: 'Alexandria, VA', path: '/chauffeur-alexandria-va' }
    ],
    longDistanceRoutes: [
      { from: 'Washington DC', to: 'New York City' },
      { from: 'Washington DC', to: 'Boston' },
      { from: 'Washington DC', to: 'Philadelphia' }
    ]
  }
}; 